import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import {
  FieldFilterOperator,
  FieldFilterOperatorFunction,
  Filter,
  PropertyType,
} from '@vendasta/multi-location-analytics';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class FilterService {
  private filters$$ = new BehaviorSubject(new Array<Filter>());
  public filters$: Observable<Filter[]>;
  public sourceFilter$: Observable<Filter>;
  private enabledSources$$: BehaviorSubject<string[]> = new BehaviorSubject([]);
  public enabledSources$: Observable<string[]>;
  private filteredSources$$: BehaviorSubject<string[]> = new BehaviorSubject([]);
  public filteredSources$: Observable<string[]>;
  public filtersQuantity$: Observable<number>;
  private subgroup$$: BehaviorSubject<string[]> = new BehaviorSubject(null);
  public subgroup$: Observable<string[]>;

  constructor() {
    this.filters$ = this.filters$$.asObservable().pipe(map((r) => [...r]));
    this.enabledSources$ = this.enabledSources$$.asObservable();
    this.filteredSources$ = this.filteredSources$$.asObservable();
    this.subgroup$ = this.subgroup$$.asObservable();
    this.sourceFilter$ = combineLatest([this.enabledSources$$, this.filteredSources$]).pipe(
      map(([enabled, filtered]) => {
        if ((!filtered || filtered.length < 1) && (!enabled || enabled.length < 1)) {
          return null;
        }
        const sourceIds = filtered && filtered.length > 0 ? filtered : enabled;
        return new Filter({
          fieldFilter: {
            operator: FieldFilterOperator.EQUAL,
            operatorFunction: FieldFilterOperatorFunction.ANY,
            dimension: 'source',
            value: {
              value: sourceIds,
              valueType: PropertyType.PROPERTY_TYPE_STRING,
            },
          },
        });
      }),
      distinctUntilChanged(),
    );
    this.filtersQuantity$ = combineLatest([this.filters$, this.filteredSources$, this.subgroup$]).pipe(
      map(([filters, filteredSources, subgroup]) => {
        let qty = 0;
        if (filters) {
          qty += filters.length;
        }
        if (filteredSources && filteredSources.length > 0) {
          qty += 1;
        }
        if (subgroup) {
          qty += 1;
        }
        return qty;
      }),
    );
  }

  public setFilters(filters: Filter[]): void {
    this.filters$$.next(filters);
  }

  public setEnabledSources(sourceIds: string[]): void {
    this.enabledSources$$.next(sourceIds);
  }

  public setFilteredSources(sourceIds: string[]): void {
    this.filteredSources$$.next(sourceIds);
  }

  public setSubgroup(groupId: string[]): void {
    this.subgroup$$.next(groupId);
  }
}
